import React from "react";
import PropTypes from "prop-types";
import SemiModal from "../semi-modal";
import styles from "./styles.css";
import CloseButton from "../icon-cross";
import { covert24hTo12h } from "../post-inspection-diy-container/selector";
import { RENDER_POPUP_TYPES } from "./constant";
import { getDateTimeObject } from "../../../utils/helpers/human-readable-date-parser";

const PostInspectionDiyTabPopUp = ({
    popupContainerType,
    postTokenDocuments,
    setPopupContainerType,
    priceBreakup,
    inspectionResponse,
    pickupDetail,
    showSelfBought = false,
    franchiseDetails
}) => {
    const {
        bank: bankDetails,
        documents
    } = postTokenDocuments || {};
    const {priceAfterDeductions} = priceBreakup || {};
    const { otherDocuments: requiredDocumentList = {} } = documents || {};
    const { carImage = ""} = inspectionResponse || {};
    const { date = "", fromTime = "", toTime = "", address } = pickupDetail || {};
    const { weekDay = "", formattedDay = "", month = "" } = getDateTimeObject(date, true);
    const time = (fromTime && toTime) ? `${covert24hTo12h(fromTime)} - ${covert24hTo12h(toTime)}` : "";
    const pickupDate = date ? `${weekDay}, ${formattedDay} ${month}, ${time}` : "";
    const Popuptype = RENDER_POPUP_TYPES[popupContainerType];
    const { title = "", component: PopupContainer } = Popuptype;
    const { isMismatchAccepted = false } = franchiseDetails || {};

    return (<SemiModal>
        <div styleName={"styles.ModalWrapper"}>
            <div styleName={"styles.modal"}>
                <div styleName={"styles.close"}>
                    <CloseButton type={"black"} onClickHandler={setPopupContainerType}/>
                </div>
                <PopupContainer
                    title={title}
                    address={address}
                    pickupDate={pickupDate}
                    setPopupContainerType={setPopupContainerType}
                    bankDetails={bankDetails}
                    priceAfterDeductions={priceAfterDeductions}
                    carImage={carImage}
                    requiredDocumentList={requiredDocumentList}
                    showSelfBought = {showSelfBought}
                    isMismatchAccepted = {isMismatchAccepted}
                />
            </div>
        </div>
    </SemiModal>);
};

PostInspectionDiyTabPopUp.propTypes = {
    popupContainerType: PropTypes.string,
    postTokenDocuments: PropTypes.object,
    setPopupContainerType: PropTypes.func,
    priceBreakup: PropTypes.any,
    inspectionResponse: PropTypes.object,
    pickupDetail: PropTypes.object,
    appointmentGeoData: PropTypes.object,
    showSelfBought: PropTypes.bool,
    franchiseDetails: PropTypes.object
};

export default PostInspectionDiyTabPopUp;
